export default {
	"autoLineStrategy": {
		"algoModel": "แบบจำลองอัลกอริทึม",
		"name": "ชื่อกลยุทธ์",
		"remark": "บรรยาย",
		"tabHeader": "ข้อมูลกลยุทธ์",
		"useTimeWindow": "พิจารณากรอบเวลาหรือไม่",
		"multTemp": "การขนส่งแบบควบคุมอุณหภูมิหรือไม่",
		"noSystemLog": "ห้ามดูข้อมูลการทำงานของระบบ",
		"dialogTitle": "เพิ่มกลยุทธ์การกำหนดเส้นทางอัตโนมัติ",
		"carSetting": "การตั้งค่ายานพาหนะ",
		"fullLoadUpper": "ขีดจำกัดสูงสุดของอัตราการบรรทุกเต็มคันรถ",
		"fullLoadLower": "ขีดจำกัดต่ำสุดของอัตราการบรรทุกเต็มคันรถ",
		"lightRatio": "อัตราส่วนปริมาตร/น้ำหนัก (ลบ.ม./ตัน)",
		"maxTransDuration": "เวลาดำเนินการขนส่งที่ยาวที่สุด",
		"lineSetting": "การตั้งค่าสายยานพาหนะ",
		"relativeDistanceWeight": "น้ำหนักและระยะทางที่สัมพันธ์กัน",
		"relativeDistance": "ค่าฐานระยะทางที่สัมพันธ์กัน",
		"deliveryPositionUpper": "ขีดจำกัดจุดส่งมอบ",
		"incideMaxDistanceRatio": "อัตราส่วนระยะทางสูงสุดของการขนส่งหลายแบบฟอร์ม",
		"regionUpper": "จำนวนสูงสุดของภูมิภาค",
		"planBeginExcuteTime": "เวลาเริ่มต้นการดำเนินการตามกำหนดเวลา",
		"wharfWorkSpeed": "ความเร็วในการดำเนินการของสถานีขนส่ง",
		"defaultUnloadSpeed": "ความเร็วในการขนถ่ายเริ่มต้น",
		"defaultJoinTime": "เวลาการส่งมอบเริ่มต้น",
		"recSendTitle": "การตั้งค่าการจัดส่งและการรับสินค้า",
		"onlyEnableStrategySelectTips": "สามารถเลือกได้เฉพาะนโยบายในสถานะเปิดใช้งานเท่านั้น"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/autoLineStrategy/autoLineStrategy.js